import { connect } from 'react-redux';

import { fetchParticipantsSearch } from 'api/participants/participants.actions';
import { ParticipantSearch } from './ParticipantSearch';

const mapDispatchToProps = (dispatch: Function) => ({
  fetchParticipantsSearch: (search: string, active?: boolean, archived?: boolean) =>
    dispatch(fetchParticipantsSearch(search, active, archived)),
});

export const ParticipantSearchContainer = connect(null, mapDispatchToProps)(ParticipantSearch);
